import React from 'react'
import PropTypes from 'prop-types'
import { MembershipCard } from 'member-portal/components'
import { DigitalWalletPass } from 'memberships/components'
import activeIcon from 'utility-icons/completed.svg'
import { DIGITAL_WALLET_TYPE } from 'config'

const propTypes = {
  isAutoRenewEnabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.string).isRequired,
  membershipNumber: PropTypes.string.isRequired,
  expirationDate: PropTypes.string.isRequired,
  applePassUrl: PropTypes.string,
  googlePassUrl: PropTypes.string,
}

function OrderConfirmationContent({
  isAutoRenewEnabled = false,
  title,
  description,
  membershipNumber,
  expirationDate,
  applePassUrl = '',
  googlePassUrl = '',
}) {
  return (
    <>
      <h2>{title}</h2>

      <hr className="divider" />

      <div className="row membership-info-container">
        <div className="membership-info-item">
          <p className="label">Membership #:</p>
          <p className="large">{membershipNumber}</p>
        </div>
        <div className="membership-info-item">
          <p className="label">Membership Expiration:</p>
          <p className="large">{expirationDate}</p>
          {isAutoRenewEnabled && (
            <div className="auto-renewal-info">
              <img src={activeIcon} alt="" className="status-icon" />
              <p>Automatically Renews on {expirationDate}</p>
            </div>
          )}
        </div>
      </div>

      <hr className="divider" />

      <div className="icon-and-text-callout">
        {description.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>

      <hr className="divider" />

      <div className="digital-passes-block">
        <p>Download your Digital Membership Card Now:</p>
        <div className="digital-passes">
          <DigitalWalletPass
            type={DIGITAL_WALLET_TYPE.APPLE}
            url={applePassUrl}
          />
          <DigitalWalletPass
            type={DIGITAL_WALLET_TYPE.GOOGLE}
            url={googlePassUrl}
          />
        </div>
        <p>
          You'll have access to your membership details and Sea Tow's contact
          information, all in one spot, saved on your phone.
        </p>
      </div>

      <hr className="divider" />

      <div className="membership-card-block">
        <MembershipCard />
      </div>
    </>
  )
}

OrderConfirmationContent.propTypes = propTypes

export default OrderConfirmationContent
